"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvroOptional = void 0;
exports.log = log;
exports.disconnect = disconnect;
exports.configure = configure;
var AvroOptional_1 = require("./AvroOptional");
Object.defineProperty(exports, "AvroOptional", { enumerable: true, get: function () { return AvroOptional_1.AvroOptional; } });
/**
 * Shims calls to the logger library to pass through to
 * a globally-provided instance of the browser transport
 */
const isBrowser = typeof window !== 'undefined' && typeof window.document !== 'undefined';
let transportConfiguration;
function log(schemaFingerprint, message) {
    if (!isBrowser) {
        throw new Error('Attempted to log from browser logger in a Node environment');
    }
    const fingerprintedMessage = { [schemaFingerprint]: message };
    if (window.signals_transport) {
        window.signals_transport.emitSignal(fingerprintedMessage);
    }
    else {
        console.log(`emitting message for \`${transportConfiguration?.endpoint ?? '(no endpoint configured)'}\` to console:`);
        console.log('(this means the signals browser transport is not present -- is this a development environment?)');
        console.log(JSON.stringify(fingerprintedMessage, null, 2));
    }
}
function disconnect() {
    if (isBrowser && window.signals_transport) {
        window.signals_transport.disconnect();
    }
}
function configure(configuration) {
    transportConfiguration = configuration;
    if (isBrowser && window.signals_transport) {
        window.signals_transport.configure(configuration);
    }
}
